import React from 'react';
import NavBar from './NavBar';

/**
 * Catch-all page. Azure Static Web Apps serves index.html with a 200 for any
 * unmatched URL, so without this the route rendered as a blank page that search
 * engines read as a soft 404. SeoManager marks unknown paths `noindex, follow`.
 */
const NotFound: React.FC = () => (
  <div className="not-found-page">
    <NavBar />
    <main className="container" style={{ padding: '8rem 1.5rem', textAlign: 'center' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>Page not found</h1>
      <p style={{ color: '#4b5563', marginBottom: '2rem' }}>
        The page you were looking for doesn&apos;t exist or has moved.
      </p>
      <p>
        <a href="/">Back to the homepage</a>
        {' · '}
        <a href="/solutions/pentities">Explore pEntities</a>
        {' · '}
        <a href="/contactus">Contact us</a>
      </p>
    </main>
  </div>
);

export default NotFound;
